import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { PRODUCTION_STATUSES } from '@/constants/production';

const Sidebar = ({ activePath, productionStatus, onProductionStatusChange, productionCounts = {} }) => {
  const { user, operators, activeOperator, setActiveOperator, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const handleChangeOperator = () => {
    setActiveOperator(null);
    navigate('/seleccionar-operador');
  };

  const links = user?.role === 'trabajador'
    ? [{ path: '/produccion', label: 'Produccion', testId: 'nav-production-link' }]
    : [
      { path: '/dashboard', label: 'Dashboard', testId: 'nav-dashboard-link' },
      { path: '/clientes', label: 'Clientes', testId: 'nav-clients-link' },
      { path: '/productos', label: 'Productos', testId: 'nav-products-link' },
      { path: '/modelos-produccion', label: 'Modelos', testId: 'nav-production-models-link' },
      { path: '/presupuestos', label: 'Presupuestos', testId: 'nav-budgets-link' },
      { path: '/presupuestos-aprobados', label: 'Aprobados', testId: 'nav-approved-budgets-link' },
      { path: '/produccion', label: 'Produccion', testId: 'nav-production-link' },
      { path: '/configuracion', label: 'Configuracion', testId: 'nav-config-link' },
      { path: '/historial', label: 'Historial', testId: 'nav-history-link' },
    ];

  const isActive = (path) => {
    if (path === '/dashboard') return activePath === '/dashboard';
    return activePath === path || activePath.startsWith(path + '/');
  };

  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <h2 data-testid="sidebar-title">Imprenta</h2>
      </div>

      <nav className="sidebar-nav">
        {links.map((link) => (
          <React.Fragment key={link.path}>
            <Link
              to={link.path}
              className={`nav-link ${isActive(link.path) ? 'active' : ''}`}
              data-testid={link.testId}
            >
              {link.label}
            </Link>
            {link.path === '/produccion' && isActive('/produccion') && onProductionStatusChange && (
              <div className="nav-submenu">
                {PRODUCTION_STATUSES.map(status => (
                  <button
                    key={status.key}
                    type="button"
                    className={`nav-sub-link ${productionStatus === status.key ? 'active' : ''}`}
                    onClick={() => onProductionStatusChange(status.key)}
                  >
                    <span>{status.label}</span>
                    <span className="mono">{productionCounts[status.key] || 0}</span>
                  </button>
                ))}
              </div>
            )}
          </React.Fragment>
        ))}
      </nav>

      <div className="sidebar-footer">
        <div className="user-info" data-testid="user-info">
          <div className="user-name">{activeOperator?.name || user?.name}</div>
          <div className="user-email">{activeOperator ? `Cuenta: ${user?.email}` : user?.email}</div>
        </div>
        {user?.role !== 'trabajador' && operators.length > 1 && (
          <button
            onClick={handleChangeOperator}
            className="btn-logout"
            data-testid="change-operator-button"
          >
            Cambiar Operador
          </button>
        )}
        <button
          onClick={handleLogout}
          className="btn-logout"
          data-testid="logout-button"
        >
          Cerrar Sesion
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
